import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const CampusIndexLazy = React.lazy(
	() => import(/* webpackChunkName : 'CampusIndex' */ './components')
);

export default () => {
	return {
		index: true,
		element: <AsyncLoading component={<CampusIndexLazy />} />,
	};
};
